import { emitter } from '@/core/emitter';
import { roundInt } from '@/core/utils';

export function creationGameSuccess(eventName) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'ok',
    title: `Game "${eventName}" created successfully`,
    detail: '',
  });
}

export function creationGameFail(error, eventName) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: `Failed to create "${eventName}" game`,
    detail: `${error}`,
  });
}

export function betCreatedNotification(orderInfo, device) {
  const mobileNoDecimalValue =
    device === 'Mobile'
      ? Number(roundInt(orderInfo.amount))
      : Number(orderInfo.amount).toFixed(2);
  emitter.emit('showAlert', {
    type: 'created-order',
    shown: true,
    status: 'ok & update',
    title: orderInfo.customTitle ? orderInfo.customTitle : 'Order submitted',
    detail: `${orderInfo.sideString} ${orderInfo.odds} · $${mobileNoDecimalValue}`,
  });
}

export function betTakenAndOrderCreatedNotification(pacakge, device) {
  const mobileNoDecimalValue =
    device === 'Mobile'
      ? Number(roundInt(pacakge.amount))
      : Number(pacakge.amount).toFixed(2);
  emitter.emit('showAlert', {
    type: 'created-order',
    shown: true,
    status: 'ok & update',
    title: 'Order filled & new offer created',
    detail: `${pacakge.sideString} ${pacakge.odds} · $${mobileNoDecimalValue}`,
  });
}

export function noBetCreatedNotification(detail = null) {
  emitter.emit('showAlert', {
    type: 'warning',
    shown: true,
    status: 'cancel',
    title: `No Offer Created`,
    detail: detail ?? `Please refresh and try again.`,
    //The original detail was: `The game may have already started, your order might have been filled immediately, or it was below the 10 threshold. Try refreshing the page.`
  });
}

export function betCreationFailedNotification(data = null) {
  const title = data && data.title ? data.title : 'Order Submission Failed';
  const detail =
    data && data.detail
      ? data.detail
      : 'This failed, please refresh the page and try again';
  emitter.emit('showAlert', {
    type: 'created-order',
    shown: true,
    status: 'danger',
    title,
    detail,
  });
}

export function betTakenNotification(betInfo, device, userStore = null) {
  const mobileNoDecimalValue =
    device === 'Mobile'
      ? Number(roundInt(betInfo.amount))
      : Number(betInfo.amount).toFixed(2);

  // Check if user has enabled confirmation ticket modal
  const showConfirmationTicket =
    userStore?.user?.displayConfirmationTicket || false;

  if (showConfirmationTicket) {
    // Show the new bet confirmation modal
    emitter.emit('showBetConfirmationModal', {
      sideString: betInfo.sideString,
      odds: betInfo.odds,
      amount: mobileNoDecimalValue,
      device: device,
      betType: betInfo.betType,
      gameInfo: betInfo.gameInfo,
    });
  } else {
    // Show the regular alert
    emitter.emit('showAlert', {
      type: 'bet-taken',
      shown: true,
      status: 'ok & update',
      title: 'Bet taken',
      detail: `${betInfo.sideString} ${betInfo.odds} · $${mobileNoDecimalValue}`,
    });
  }

  emitter.emit('get-me');
}

export function betTakenFailedNotification(data) {
  let title;
  let detail;
  if (data && data.title && data.detail) {
    title = data.title;
    detail = data.detail;
  } else {
    title = 'Bet Taken Failed';
    detail = data || 'This failed, please refresh the page and try again';
  }
  emitter.emit('showAlert', {
    type: 'bet-taken',
    shown: true,
    status: 'danger',
    title,
    detail,
  });
}

export function userLoginFailedNotification(data) {
  let message = 'Unable to log in, please try again later';
  if (
    data === 'Username or password is incorrect' ||
    data.message === 'Username or password is incorrect' ||
    (typeof data.message === 'string' && data.message.includes('closed'))
  ) {
    message = data;
  }
  emitter.emit('showAlert', {
    shown: true,
    status: 'danger',
    title: message,
    detail: '',
  });
}

export function cancelOfferNotification(description, remaining, odds) {
  emitter.emit('showAlert', {
    type: 'canceled-order',
    shown: true,
    status: 'cancel',
    title: 'Order cancelled',
    detail: `${description} ${odds} · $${Number(remaining).toFixed(2)}`,
  });
}

export function cancelOfferFailedNotification() {
  emitter.emit('showAlert', {
    type: 'canceled-order',
    shown: true,
    status: 'danger',
    title: 'Order Not Canceled. Please Try Again',
    detail: '',
  });
}

//CASHIER////////
export function depositRequestSuccess() {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'ok',
    title: 'Deposit request',
    detail: 'Deposit successfully requested',
  });
}

export function depositRequestFail(error) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: 'Deposit request failed',
    detail: `${error}`,
  });
}

export function depositMethodRequestSuccess() {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'ok',
    title: 'Request Sent',
    detail: "We'll Consider Adding Popular Requests",
  });
}

export function depositMethodRequestFail(error) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: 'Request failed',
    detail: `${error}`,
  });
}
export function markAsSentSuccess() {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'ok',
    title: 'Mark as sent request',
    detail: 'Deposit successfully marked as sent',
  });
}

export function markAsSentFail(error) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: 'Mark as sent request',
    detail: `${error}`,
  });
}
export function cancelDepositRequestSuccess() {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'ok',
    title: 'Cancel deposit request',
    detail: 'Deposit successfully cancelled',
  });
}

export function cancelDepositRequestFail(error) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: 'Cancel deposit request',
    detail: `${error}`,
  });
}

export function withdrawalRequestSuccess(message) {
  emitter.emit('showAlert', {
    type: 'balance-update',
    shown: true,
    status: 'ok',
    title: 'Withdrawal Request',
    detail: `${message}`,
  });
}

export function withdrawalRequestFail(error) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: 'Withdrawal request failed',
    detail: `${error}`,
  });
}

export function cancelWithdrawalRequestSuccess(message) {
  emitter.emit('showAlert', {
    type: 'balance-update',
    shown: true,
    status: 'ok',
    title: 'Withdrawal Request',
    detail: `${message}`,
  });
}

export function cancelWithdrawalRequestFail(error) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: 'Withdrawal request failed',
    detail: `${error}`,
  });
}

export function confirmWithdrawalRequestSuccess(message) {
  emitter.emit('showAlert', {
    shown: true,
    status: 'ok',
    title: 'Withdrawal Request',
    detail: `${message}`,
  });
}

export function confirmWithdrawalRequestFail(error) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: 'Withdrawal request failed',
    detail: `${error}`,
  });
}
///////////
export function submitEditOrderSuccessNotification(orderInfo) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'ok & update',
    title: 'Order edited',
    detail: `${orderInfo.sideString} ${orderInfo.odds} · $${Number(orderInfo.amount).toFixed(2)}`,
  });
}

export function submitEditOrderFailedNotification(data = null) {
  const title = data && data.title ? data.title : 'Order Submission Failed';
  const detail =
    data && data.detail
      ? data.detail
      : 'This failed, please refresh the page and try again';
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title,
    detail,
  });
}

export function socketStatus() {}

//SINGUP////////
export function validateAccessCodeRequestSuccess(payload) {
  emitter.emit('showAlert', {
    shown: true,
    status: 'ok',
    title: `${payload} is a valid access code!`,
    detail: '',
  });
}

export function validateAccessCodeRequestRequestFail(error) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: `${error}`,
    detail: '',
  });
}

export function validateAccessCodeFail(payload) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: `${payload} is a invalid access code!`,
    detail: '',
  });
}

export function specialCharactersUser() {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: 'Username cannot contain special characters',
    detail: '',
  });
}

export function validateUserRequestFail(error) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: `${error}`,
    detail: '',
  });
}

export function signUpRequestFail(error) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: `${error}`,
    detail: '',
  });
}

export function contactInfoSuccess(payload) {
  emitter.emit('showAlert', {
    shown: true,
    status: 'ok',
    title: 'Your information has been saved',
    detail: 'We will contact you when you can join!',
  });
}

export function contactInfoError() {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: 'We need contact information',
    detail: '',
  });
}

export function sendEmailError(error) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: `${error}`,
    detail: '',
  });
}

export function surveySentSuccess() {
  emitter.emit('showAlert', {
    shown: true,
    status: 'ok',
    title: 'Survey submitted. You will hear back when you can sign up!',
    detail: '',
  });
}

export function surveySentFail(error) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: `${error}`,
    detail: '',
  });
}

export function mockOrdersUpdated() {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'ok',
    title: 'Mock Orders Updated',
    detail: '',
  });
}

export function getMockOrdersFailNotification(detail) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: `Order failed to initalize`,
    detail,
  });
}

export function ordersSubmittedNotification(eventName) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'ok',
    title: `Orders on "${eventName}" successfully submitted`,
  });
}

export function monkeyOrdersSubmitFailNotification(error, eventName) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: `Orders on "${eventName}" failed to submit`,
    detail: `${error}`,
  });
}

export function cancelMonkeyActiveOrderNotification(eventName) {
  emitter.emit('showAlert', {
    type: 'canceled-order',
    shown: true,
    status: 'cancel',
    title: 'Orders Cancelled',
    detail: `Canceled Orders for ${eventName}`,
  });
}

export function cancelMonkeyActiveOrderFailNotification(error, eventName) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: `Failed to cancel orders on "${eventName}"`,
    detail: `${error}`,
  });
}

export function missingEmailError() {
  emitter.emit('showAlert', {
    shown: true,
    status: 'danger',
    title: 'Email field empty',
    detail: '',
  });
}

export function invalidEmailFormatError() {
  emitter.emit('showAlert', {
    shown: true,
    status: 'danger',
    title: 'Invalid Email',
    detail: '',
  });
}

//////AFFILATE SUMMARY////////
export function transactionReverseSuccess(eventName) {
  emitter.emit('showAlert', {
    type: 'reverse-transaction',
    shown: true,
    status: 'ok',
    title: 'Transaction reversed',
    detail: '',
  });
}

export function userBlockedSuccess(lockOrUnlock) {
  emitter.emit('showAlert', {
    type: 'blocked-user',
    shown: true,
    status: 'ok',
    title: lockOrUnlock === 'unlock' ? 'Unlocked user' : 'User locked',
    detail: '',
  });
}

export function accountClosedSuccess() {
  emitter.emit('showAlert', {
    type: 'close-account',
    shown: true,
    status: 'ok',
    title: 'Players account closed',
    detail: '',
  });
}

export function balanceTransferSuccess() {
  emitter.emit('showAlert', {
    type: 'balance-update',
    shown: true,
    status: 'ok',
    title: 'Balance transferred!',
    detail: '',
  });
}

export function balanceTransferFail(error) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: error,
    detail: '',
  });
}

export function creditLimitUpdateSuccess(player, updatedCredit) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'ok',
    title: 'Updated credit!',
    detail: `${player.username} credit changed to (${updatedCredit})`,
  });
}

export function creditLimitUpdateFail(error) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: error,
    detail: '',
  });
}

export function updateNoteSuccess() {
  emitter.emit('showAlert', {
    shown: true,
    status: 'ok',
    title: 'Updated note!',
    detail: '',
  });
}

export function updateNoteFail(error) {
  emitter.emit('showAlert', {
    shown: true,
    status: 'danger',
    title: error,
    detail: '',
  });
}

export function updatePasswordSuccess(payload) {
  emitter.emit('showAlert', {
    shown: true,
    status: 'ok',
    title: payload.message,
    detail: '',
  });
}

export function updatePasswordFail(error) {
  emitter.emit('showAlert', {
    shown: true,
    status: 'danger',
    title: error,
    detail: '',
  });
}

export function referralLinkCopiedSuccess(payload) {
  emitter.emit('showAlert', {
    type: 'player-balance-updated',
    shown: true,
    status: 'ok',
    title: 'Referral link copied to clipboard',
    detail: '',
  });
}

export function clearBalanceSuccess() {
  emitter.emit('showAlert', {
    type: 'balance-update',
    shown: true,
    status: 'ok',
    title: 'Player balances updated',
    detail: '',
  });
}

export function clearBalanceUnable(players) {
  players.forEach((player) => {
    emitter.emit('showAlert', {
      type: 'warning',
      shown: true,
      status: 'cancel',
      title: `Unable to clear ${player.username} balance`,
      detail: 'User exceeds credit due to pending bets',
    });
  });
}

export function clearBalanceFail(error) {
  emitter.emit('showAlert', {
    type: 'player-balance-updated',
    shown: true,
    status: 'danger',
    title: r,
    detail: '',
  });
}

export function guestInviteRequestSuccess() {
  emitter.emit('showAlert', {
    shown: true,
    status: 'ok',
    title: 'The user has successfully registered',
    detail: '',
  });
}

export function guestInviteRequestFail(error) {
  emitter.emit('showAlert', {
    shown: true,
    status: 'danger',
    title: error,
    detail: '',
  });
}

export function updateCrytoAddressSuccess() {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'ok',
    title: 'Updated crypto address!',
    detail: '',
  });
}

export function updateCrytoAddressFail(error) {
  emitter.emit('showAlert', {
    shown: true,
    status: 'danger',
    title: error,
    detail: '',
  });
}

export function updateComissionSuccess() {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'ok',
    title: 'Comission updated!',
    detail: '',
  });
}

export function updateComissionFail(error) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: error,
    detail: '',
  });
}

export function monkeyOrderEditedNotification(eventName) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'ok',
    title: 'Orders Edited',
    detail: eventName,
  });
}

export function monkeyOrderEditFailedNotification(eventName) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: `Error Editing Orders for ${eventName}`,
    detail: '',
  });
}

export function monkeySetDefaultSuccess() {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'ok',
    title: 'Default values successfully saved',
    detail: '',
  });
}

export function monkeySetDefaultFail() {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: 'Failed to save default values',
    detail: '',
  });
}

export function circleGameSuccessNotification(gameName) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'ok',
    title: `Game "${gameName}" successfully circled`,
    detail: '',
  });
}

export function circleGameFailedNotification(error) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: 'Failed to circle game',
    detail: error,
  });
}

export function polySuppressSuccessNotification(gameName) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'ok',
    title: `Game "${gameName}" poly suppressed`,
    detail: '',
  });
}

export function polySuppressFailedNotification(error) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: 'Failed to poly suppress game',
    detail: error,
  });
}

export function polyUnsuppressSuccessNotification(gameName) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'ok',
    title: `Game "${gameName}" poly unsuppressed`,
    detail: '',
  });
}

///PAUSE/RESUME - COMMENTED OUT///////
// export function noOrderToPause() {
//   emitter.emit('showAlert', {
//     type: 'canceled-order',
//     shown: true,
//     status: 'warning',
//     title: 'The user has no open orders',
//     detail: '',
//   });
// }

// export function ordersPausedSuccess() {
//   emitter.emit('showAlert', {
//     type: 'canceled-order',
//     shown: true,
//     status: 'ok',
//     title: 'Pause Orders Received',
//     detail: '',
//   });
// }

// export function ordersPauseError() {
//   emitter.emit('showAlert', {
//     type: 'canceled-order',
//     shown: true,
//     status: 'danger',
//     title: 'Error Pausing Orders',
//     detail: '',
//   });
// }

// export function checkPausedOrdersError() {
//   emitter.emit('showAlert', {
//     type: 'canceled-order',
//     shown: true,
//     status: 'danger',
//     title: 'Error',
//     detail:
//       'Something went wrong while checking for paused orders, please try again later',
//   });
// }

// export function resumeOrderSuccess() {
//   emitter.emit('showAlert', {
//     type: 'submit-edit-order',
//     shown: true,
//     status: 'ok',
//     title: 'Order Resumed',
//     detail: '',
//   });
// }

// export function resumeOrderFail() {
//   emitter.emit('showAlert', {
//     type: 'canceled-order',
//     shown: true,
//     status: 'danger',
//     title: 'Error Resuming Order',
//     detail: '',
//   });
// }

// export function resumeAllOrdersSuccess() {
//   emitter.emit('showAlert', {
//     type: 'submit-edit-order',
//     shown: true,
//     status: 'ok',
//     title: 'All Orders Resumed',
//     detail: '',
//   });
// }

// export function resumeAllOrdersFail() {
//   emitter.emit('showAlert', {
//     type: 'canceled-order',
//     shown: true,
//     status: 'danger',
//     title: 'Error Resuming Paused Orders',
//     detail: '',
//   });
// }

// export function removeAllOrdersSuccess() {
//   emitter.emit('showAlert', {
//     type: 'submit-edit-order',
//     shown: true,
//     status: 'ok',
//     title: 'Paused Orders Queue Cleared',
//     detail: '',
//   });
// }

// export function removeAllOrdersFail() {
//   emitter.emit('showAlert', {
//     type: 'canceled-order',
//     shown: true,
//     status: 'danger',
//     title: 'Error Removing Paused Orders',
//     detail: '',
//   });
// }

// export function removeOrderSuccess() {
//   emitter.emit('showAlert', {
//     type: 'canceled-order',
//     shown: true,
//     status: 'warning',
//     title: 'Paused Order Deleted',
//     detail: '',
//   });
// }

export function bestOfferGameStarted() {
  emitter.emit('showAlert', {
    type: 'warning',
    shown: true,
    status: 'danger',
    title: `Game Has Already Started`,
    detail: `Best Offers will refresh soon`,
  });
}

export function affiliateKickbackRateSuccess(percentLabel) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'ok',
    title: 'Kickback Rate Updated',
    detail: `Affiliate is now on ${percentLabel}.`,
  });
}

export function affiliateKickbackRateFail(error) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: 'Failed to Update Kickback Rate',
    detail: `${error?.message || error || 'Please try again.'}`,
  });
}

/////////////PAUSE/RESUME - COMMENTED OUT///////////////
/////////////Request Verification//////////////////////
export function verificationRequestedSuccess() {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'ok',
    title: 'Verification Requested',
    detail: 'Verification request sent successfully',
  });
}

export function verificationRequestedFail(error) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: 'Failed to Request Verification',
    detail: `${error?.message || error || 'Please try again.'}`,
  });
}
////////////////////////////////////////////////////////
export function feedbackSuccess() {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'ok',
    title: 'Feedback sent',
    detail: 'Thanks for helping us improve',
  });
}

export function feedbackFail(error) {
  emitter.emit('showAlert', {
    type: 'submit-edit-order',
    shown: true,
    status: 'danger',
    title: 'Feedback failed',
    detail: `${error}`,
  });
}
